module.exports = __webpack_public_path__ + "static/media/M Mall 2.17ee4136.png";